import { PagamentoWithDettaglioDTO } from '@framework/api-client';
import { t } from '@framework/i18n';
import { CopyableId, CurrencyRender } from '@framework/ui';
import { Space } from 'antd';
import { ColumnGroupType, ColumnType, ColumnsType } from 'antd/es/table';
import React from 'react';
import { EnumCodStatoPagamento } from './EnumCodStatoPagamento';
import { PaymentStateTag } from './PaymentStateTag';

export const paymentsColumnsBase = {
  codice: {
    title: t('payment-columns.codice', 'Codice'),
    dataIndex: 'codice',
    key: 'codice',
    render: (_, record) => {
      if (record.iuv) {
        return (
          <Space>
            <b>IUV</b>
            {record.iuv}
            <CopyableId id={record.iuv} />
          </Space>
        );
      }
      if (record.bolloRid) {
        return (
          <Space>
            <b>RID</b>
            {record.bolloRid}
            <CopyableId id={record.bolloRid} />
          </Space>
        );
      }
      return null;
    },
  },
  valore: {
    title: t('payment-columns.importo', 'Importo'),
    dataIndex: 'valore',
    key: 'valore',
    align: 'right',
    render: (_, record) => <CurrencyRender value={record.valore} />,
  },
  stato: {
    title: t('payment-columns.stato-pagamento', 'Stato Pagamento'),
    dataIndex: 'stato',
    key: 'stato',
    render: (_, record) => (
      <PaymentStateTag
        state={record.codStatoPagamento as EnumCodStatoPagamento}
      />
    ),
  },
} satisfies Record<
  string,
  | ColumnGroupType<PagamentoWithDettaglioDTO>
  | ColumnType<PagamentoWithDettaglioDTO>
>;

export const paymentsColumns: ColumnsType<PagamentoWithDettaglioDTO> = [
  paymentsColumnsBase.stato,
  paymentsColumnsBase.valore,
  paymentsColumnsBase.codice,
];

export const paymentsColumnsMobile: ColumnsType<PagamentoWithDettaglioDTO> = [
  paymentsColumnsBase.stato,
  paymentsColumnsBase.valore,
  paymentsColumnsBase.codice,
];
